<!-- <h1>Hello world </h1>

<p>{{'enclaves.town' | translate}}</p>

<button (click)="switchLang('es')">ES</button>
    <button (click)="switchLang('en')">EN</button> -->

<app-header></app-header>
<router-outlet />
<app-footer></app-footer>
<app-cookie-banner></app-cookie-banner>
